// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sentry from "../../../../../../library/sentry/Sentry.bs.js";
import * as UserRoles from "../../types/workspace/UserRoles.bs.js";
import * as CookieUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/CookieUtils.bs.js";

var emptyUserRoles = {
  user_roles: /* [] */0
};

var hasReported = {
  contents: false
};

function reportOnce(detail) {
  if (!hasReported.contents) {
    hasReported.contents = true;
    return Sentry.captureException(undefined, {
                error_kind: "COOKIE_UNREADABLE",
                type: "COOKIE_UNREADABLE",
                caught_by: "WorkSpaceRepo"
              }, Sentry.makeError("Could not read the user_roles cookie", detail));
  }
  
}

function fetchUserRoles(param) {
  var user_roles_cookie = CookieUtils$Catalyst.getCookie("user_roles");
  var roles = UserRoles.t_decode(user_roles_cookie);
  if (roles.TAG === /* Ok */0) {
    return roles._0;
  }
  var error = roles._0;
  reportOnce(error.path + " " + error.message);
  return emptyUserRoles;
}

var WorkSpaceRepo = {
  fetchUserRoles: fetchUserRoles
};

export {
  emptyUserRoles ,
  hasReported ,
  reportOnce ,
  WorkSpaceRepo ,
  
}
/* Sentry Not a pure module */
